module.exports = __webpack_public_path__ + "static/media/car-large.dbc8210b.jpg";